import React from 'react';
import { Badge } from 'react-bootstrap';
import { CollectionOrderStates } from 'shared-pages/common/constants';

const normalizeCollectionOrderStatusLabel = (name?: string): string | undefined =>
  name
    ?.replace('Η Αίτηση', 'Το Αίτημα')
    .replace('η αίτηση', 'το αίτημα')
    .replace('Αίτησης', 'Αιτήματος')
    .replace('αίτησης', 'αιτήματος')
    .replace('Αίτηση', 'Αίτημα')
    .replace('αίτηση', 'αίτημα');

export const CollectionOrdersStatusesBadge = ({
  value,
  name,
}: {
  value?: number;
  name?: string;
}) => {
  const resolvedValue = value ?? CollectionOrderStates.NotRouted;
  const displayName = normalizeCollectionOrderStatusLabel(name);

  const variant =
    resolvedValue === CollectionOrderStates.NotRouted
      ? 'warning'
      : resolvedValue === CollectionOrderStates.Routed
      ? 'primary'
      : resolvedValue === CollectionOrderStates.Executed
      ? 'success'
      : 'secondary';

  return (
    <Badge bg={variant} pill className="status-row-badge">
      {displayName ?? '---'}
    </Badge>
  );
};
